export default function getShortClusterId(id: string): string {
  const FIRST_SYMBOL_COUNT = 4;
  const LAST_SYMBOL_COUNT = 4;
  const MIN_ID_LENGTH = FIRST_SYMBOL_COUNT + LAST_SYMBOL_COUNT;

  return id.length < MIN_ID_LENGTH
    ? id
    : `${id.slice(0, FIRST_SYMBOL_COUNT)}-${id.slice(-LAST_SYMBOL_COUNT)}`;
}
